import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.appindeasa.com/api', // tu backend
});

// Interceptor para enviar token en cada request
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;